/*
 * This file is auto-generated. Do not modify it manually!
 * Run 'yarn workspace @proton/icons build' to update the icons react components.
 */
import React from 'react';

import type { IconSize } from '../types';

interface IconProps extends React.SVGProps<SVGSVGElement> {
    /** If specified, renders an sr-only element for screenreaders */
    alt?: string;
    /** If specified, renders an inline title element */
    title?: string;
    /**
     * The size of the icon
     * Refer to the sizing taxonomy: https://design-system.protontech.ch/?path=/docs/components-icon--basic#sizing
     */
    size?: IconSize;
}

export const IcEarth = ({ alt, title, size = 4, className = '', viewBox = '0 0 16 16', ...rest }: IconProps) => {
    return (
        <>
            <svg
                viewBox={viewBox}
                className={`icon-size-${size} ${className}`}
                role="img"
                focusable="false"
                aria-hidden="true"
                {...rest}
            >
                {title ? <title>{title}</title> : null}

                <path
                    fillRule="evenodd"
                    d="M13.934 8.897a6.001 6.001 0 0 1-11.837.183 2.5 2.5 0 0 0 2.237.663l.36-.072a.5.5 0 0 1 .579.353l.604 2.115a1.484 1.484 0 0 0 2.866-.048l.148-.595a.5.5 0 0 1 .208-.294l.957-.639a1.5 1.5 0 0 0 .51-.577l.059-.118a1.5 1.5 0 0 0-.281-1.731l-.698-.698A1.5 1.5 0 0 0 8.586 7h-.893a.5.5 0 0 1-.186-.036l-1.29-.516A.232.232 0 0 1 6.303 6h1.034a1.189 1.189 0 0 0 .84-2.03l-.636-.637 1.206-.2a1.5 1.5 0 0 0 1.11-.84 6 6 0 0 1 2.427 1.506l-.732.366A1.5 1.5 0 0 0 10.8 5.98l.542 1.627a1.5 1.5 0 0 0 1.129.996l1.463.293Zm-.996-4.307a5.97 5.97 0 0 1 1.061 3.3l-1.332-.266a.5.5 0 0 1-.376-.333l-.542-1.626a.5.5 0 0 1 .25-.606l.939-.469ZM8 2c.271 0 .538.018.8.053a.499.499 0 0 1-.218.093l-1.206.201a1 1 0 0 0-.543 1.694l.638.637A.189.189 0 0 1 7.337 5H6.303a1.232 1.232 0 0 0-.457 2.377l1.29.516A1.5 1.5 0 0 0 7.693 8h.893a.5.5 0 0 1 .353.146l.698.698a.5.5 0 0 1 .093.577l-.058.118a.5.5 0 0 1-.17.192l-.958.639a1.5 1.5 0 0 0-.623.884l-.148.594a.484.484 0 0 1-.935.016l-.604-2.115a1.5 1.5 0 0 0-1.736-1.058l-.36.072a1.5 1.5 0 0 1-1.494-.571l-.612-.816A6 6 0 0 1 8 2Zm0 13A7 7 0 1 0 8 1a7 7 0 0 0 0 14Z"
                    className="Union"
                ></path>
            </svg>
            {alt ? <span className="sr-only">{alt}</span> : null}
        </>
    );
};
